<template>
  <footer class="footer-area">
    <div class="footer-bottom-wrapper">
      <div class="footer-inner">
      <div class="footer-logos">
        <img
          class="logo-footer logo-footer--primary"
          :src="require('../assets/img/imgs/logo3.png')"
          alt=""
        />
        <img
          class="logo-footer"
          :src="require('../assets/img/imgs/logo2.png')"
          alt=""
        />
        <img
          class="logo-footer"
          :src="require('../assets/img/imgs/logo1.png')"
          alt=""
        />
      </div>
      <div class="footer-links">
        <span role="button" class="footer-link" @click="openBanquan">{{ getBanquanText() }}</span>
        <span class="footer-sep">|</span>
        <span role="button" class="footer-link" @click="openMianze">{{ getMianzeText() }}</span>
      </div>
    </div>
  </div>

  <!-- 版權公告彈窗 -->
  <el-dialog
    :title="getBanquanText()"
    :visible.sync="dialogBanquanVisible"
    width="90%"
    custom-class="footer-dialog"
    :append-to-body="true"
    :close-on-click-modal="true"
  >
    <div class="footer-dialog__content" v-html="getBanquanContent()"></div>
  </el-dialog>

  <!-- 免責聲明彈窗 -->
  <el-dialog
    :title="getMianzeText()"
    :visible.sync="dialogMianzeVisible"
    width="90%"
    custom-class="footer-dialog"
    :append-to-body="true"
    :close-on-click-modal="true"
  >
    <div class="footer-dialog__content" v-html="getMianzeContent()"></div>
  </el-dialog>
  </footer>
</template>
<script>
/* eslint-disable */
import { getConfig } from "@/axios/api";
export default {
  name: "footerComponent",
  data() {
    return {
      footer: {},
      banquan: '版权公告',
      mianze: '免责声明',
      dialogBanquanVisible: false,
      dialogMianzeVisible: false
    };
  },
  created() {},
  mounted() {
    this.getConfig();
    window.translate.execute()
  },
  methods: {
    getMianzeText () {      
      var btnText = this.mianze
      const lang = window.translate.language.getCurrent()
      if (lang === 'english') {
        btnText = 'Disclaimer'
      }
      if (lang === 'chinese_traditional') {
        btnText = '免責聲明'
      }
      return btnText
    },
    getBanquanText() {
      const lang = window.translate.language.getCurrent();
      if (lang === 'english') return 'Copyright Notice';
      if (lang === 'chinese_traditional') return '版權公告';
      return '版权公告';
    },
    getBanquanContent() {
      const lang = window.translate.language.getCurrent();
      const year = new Date().getFullYear();
      if (lang === 'english') {
        return '<p>The content of this website is owned by the project. Unauthorised reproduction or distribution is prohibited.</p><p>© ' + year + ' All rights reserved.</p>';
      }
      if (lang === 'chinese_traditional') {
        return '<p>本網站內容版權歸項目方所有，未經授權不得轉載或使用。</p><p>© ' + year + ' 保留所有權利。</p>';
      }
      return '<p>本网站内容版权归项目方所有，未经授权不得转载或使用。</p><p>© ' + year + ' 保留所有权利。</p>';
    },
    getMianzeContent() {
      const lang = window.translate.language.getCurrent();
      if (lang === 'english') {
        return '<p>The information on this website is for reference only. Project details are subject to the latest announcements by the Government and the contractor.</p>';
      }
      if (lang === 'chinese_traditional') {
        return '<p>本網站資訊僅供參考，項目詳情以政府及承建商最新公布為準。</p>';
      }
      return '<p>本网站资讯仅供参考，项目详情以政府及承建商最新公布为准。</p>';
    },
    openBanquan() {
      this.dialogBanquanVisible = true;
    },
    openMianze() {
      this.dialogMianzeVisible = true;
    },
    getConfig() {
      if (sessionStorage.getItem("pageConfig")) {
        const data = JSON.parse(sessionStorage.getItem("pageConfig"));
        this.footer = data.configs;
        window.translate.execute()
        // this.trans();
        return;
      }
      getConfig().then((res) => {
        this.footer = res.data.configs;
        window.translate.execute()
        // this.trans();
      });
    },
    getUrl() {
      let str = "";
      const lang = window.translate.language.getCurrent();
      if (lang === "english") {
        str = "https://www.dsd.gov.hk/EN/Home/index.html";
      }
      if (lang === "chinese_simplified") {
        str = "https://www.dsd.gov.hk/SC/Home/index.html";
      }
      if (lang === "chinese_traditional") {
        str = "https://www.dsd.gov.hk/TC/Home/index.html";
      }
      return str;
    },
    getUrl1() {
      let str = "";
      const lang = window.translate.language.getCurrent();
      if (lang === "english") {
        str = "https://cscechk.com/en/index.php";
      }
      if (lang === "chinese_simplified") {
        str = "https://cscechk.com/tc/index.php";
      }
      if (lang === "chinese_traditional") {
        str = "https://cscechk.com/tc/index.php";
      }
      return str;
    },
    trans() {
      this.$nextTick(() => {
        // window.translate.request.api.host = "https://tr.yuenlongbarrage.hk/"; // 将这里面的ip地址换成你服务器的ip，注意开头，及结尾还有个 / 别拉下
        // // 指定翻译服务为使用 translate.service
        // window.translate.execute(); // 进行翻译
      });
    },
  },
};
</script>
<style lang="less" scoped>
.footer-area {
  width: 100%;
  background: #fff;
  border-top: 1px solid #e8ecef;
  // margin-top: 3.75rem;
}

.footer-bottom-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 1rem 2rem;
}

.footer-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.footer-logos {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 1.5rem;
}

.logo-footer {
  height: auto;
  max-height: 56px;
  width: auto;
  max-width: 120px;
  object-fit: contain;
  display: block;
}

.logo-footer--primary {
  max-height: 100px;
  max-width: 160px;
}

.footer-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.7rem;
  color: #5c6370;
}

.footer-sep {
  color: #c0c4cc;
  user-select: none;
}

.footer-link {
  color: #68dbd6;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: #52c5c0;
  text-decoration: underline;
}
.footer-link[role="button"] {
  cursor: pointer;
}

/* 平板 */
@media (max-width: 991px) {
  .footer-area {
    margin-top: 2.5rem;
  }

  .footer-bottom-wrapper {
    padding: 1.75rem 1rem 2.5rem;
  }

  .footer-inner {
    justify-content: center;
    text-align: center;
  }

  .footer-logos {
    justify-content: center;
  }

  .footer-links {
    justify-content: center;
  }
}

/* 移动端 */
@media (max-width: 767px) {
  .footer-area {
    margin-top: 2rem;
  }

  .footer-bottom-wrapper {
    padding: 1.5rem 1rem 2rem;
  }

  .footer-inner {
    flex-direction: column;
    gap: 1.25rem;
  }

  .footer-logos {
    flex-direction: column;
    gap: 0.75rem;
  }

  .logo-footer {
    max-height: 48px;
    max-width: 100px;
  }

  .logo-footer--primary {
    max-height: 80px;
    max-width: 140px;
  }

  .footer-links {
    font-size: 0.8125rem;
    justify-content: center;
  }
}
</style>
<style lang="less">
/* 底部彈窗樣式（append-to-body 後 wrapper 與 v-modal 同級於 body，需彈窗在遮罩之上） */
.el-dialog__wrapper:has(.footer-dialog) {
  z-index: 3001 !important;
}
.footer-dialog {
  max-width: 480px;
  border-radius: 8px;
  .el-dialog__header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #e8ecef;
    .el-dialog__title {
      font-size: 1rem;
      color: #27273d;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #909399;
    }
  }
  .el-dialog__body {
    padding: 20px;
  }
}
.footer-dialog__content {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #5c6370;
  p {
    margin: 0 0 0.75em;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
